<template>
  <button
    v-if="!props.disabled"
    ref="displayControlRef"
    type="button"
    :class="displayControlClasses"
    :aria-label="displayControlLabel"
    :aria-describedby="props.errorMessageIds"
    data-cy="ds-title-field__display-control"
    @click="emit('activate')"
    @focus="emit('focus', $event)"
    @blur="emit('blur', $event)"
  >
    <span :class="displayContentClasses">
      <span
        v-if="displayValue"
        :class="DS_TITLE_FIELD_CLASSES.DisplayText"
      >
        {{ displayValue }}
      </span>
      <template v-else>
        <span
          :class="[DS_TITLE_FIELD_CLASSES.EmptyHint, DS_TITLE_FIELD_CLASSES.EmptyHoverHint]"
          aria-hidden="true"
          data-cy="ds-title-field__empty-hover-hint"
        >
          {{ titleClickForEdit }}
        </span>
        <span
          :class="[DS_TITLE_FIELD_CLASSES.EmptyHint, DS_TITLE_FIELD_CLASSES.EmptyFocusHint]"
          aria-hidden="true"
          data-cy="ds-title-field__empty-focus-hint"
        >
          {{ titleEnterForEdit }}
        </span>
      </template>
    </span>
  </button>

  <span
    v-else
    :class="displayControlClasses"
    :aria-describedby="props.errorMessageIds"
    aria-disabled="true"
    data-cy="ds-title-field__disabled-display"
  >
    <span :class="displayContentClasses">
      <span
        v-if="displayValue"
        :class="DS_TITLE_FIELD_CLASSES.DisplayText"
      >
        {{ displayValue }}
      </span>
    </span>
  </span>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useDSInput } from "@/src/design_system/form_elements/shared/composables/useDSInput";
import { useDSTitleFieldDisplay } from "@/src/design_system/form_elements/title_field/composables/useDSTitleFieldDisplay";
import { DS_TITLE_FIELD_CLASSES } from "@/src/design_system/form_elements/title_field/constants/classes";
import type { DSTitleFieldDisplayProps } from "@/src/design_system/form_elements/title_field/types/internal";
import type { DSTitleFieldDisplayEmits } from "../types/emits";

const props = defineProps<DSTitleFieldDisplayProps>();
const emit = defineEmits<DSTitleFieldDisplayEmits>();
const displayControlRef = ref<HTMLButtonElement>();
const titleClickForEdit = window.I18n.designSystem.titleField.clickForEdit;
const titleEnterForEdit = window.I18n.designSystem.titleField.enterForEdit;

const { displayValue, displayControlLabel, displayControlClasses, displayContentClasses } =
  useDSTitleFieldDisplay(props);
const { focus, blur } = useDSInput(displayControlRef);

defineExpose({ focus, blur });
</script>
